// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

:host ::ng-deep .p-treetable .p-treetable-tbody > tr > td {
  padding: 0;
}

:host ::ng-deep .p-sidebar .p-sidebar-header {
  display: flex;
  flex-direction: row-reverse;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
